<template>
  <div>
    <div class="totop" v-if="showToTop" @click="gotoTop()">
      <img :src="require('../../static/img/totop.png')">
    </div>
    <div v-if="noProduct" class="noproduct">
        <img :src="require('../../static/img/noproduct.png')"/>
    </div>
    <div v-if="isReload">
      <div v-if="type==headType.wxShare">
        <v-tao  v-for="(taoke,index) in taokes" :item="taoke" :key="taoke.GoodsID" :types="types"  :idx="index"></v-tao>
      </div>
      <div v-else>
        <v-double  v-for="(taoke,index) in taokes" :item="taoke" :key="taoke.GoodsID" :type="type" :types="types" :idx="index"></v-double>
      </div>
    </div>
    <div v-else :style="bodyStyle">
      <div  style="text-align:center" >
        <img style="margin-top:30%;width:40px;height:40px" :src="require('../../static/img/loading.gif')" v-if="!(type==headType.wxShare)"/>
      </div>
      <div  style="text-align:center;margin-top:10px;color: #4c4c4c">
        努力加载中...
      </div>
    </div>
    <div class="loading">
      <div  :class="loadCss" v-if="isUpPage" >
        正在加载。。。
      </div>
      <div v-else>
        <span style="color: #4c4c4c" v-if="!isEnd">下拉显示更多</span>
        <span style="color: #4c4c4c" v-else>没有更多产品</span>
      </div>
    </div>
  </div>
</template>
<script>
  import Double from './taoke/Double.vue';
  import Tao from './wxShare/Tao.vue';
  export default{
    name:'body',
    props:['type','item','types'],
    data(){
      return {
        page:0,
        param:'normal=1',
        endParam:'',
        key:this.$route.query.keyword,
        isReload:false,
        isUpPage:false,
        isEnd:false,
        aliSearch:false,
        pageNum:2,
        loadCss:'load',
        bodyStyle:{},
        scrollAction:{x: 'undefined', y: 'undefined'},
        scrollDirection:'',
        top:window.screen.availHeight*2,
        taokes:[],
        showToTop:false,
        noProduct:false,
        idxPageMap:{}
      }
    },
    beforeRouteUpdate(to,from,next){
      this.init();
      next();
    },
    mounted(){
      if(this.type==this.headType.wxShare){
        this.loadCss="loadForWx";
      }
      this.count();
      this.setStyle();
      var self = this;
      window.addEventListener("scroll",function(){
        self.scrollFunc();
        self.downToReload();
        self.floatBanner();
        self.toShowToTop();
      },false);
      self.getTaokes(self.page,this.public.getParam(),false);
    },
    watch:{
      page:function(p){
        if(p>0){
          this.isUpPage=true;
          this.getTaokes(p,this.public.getParam(),true);
        }
      },
      'public.reload':function(r){
        this.init();
        this.setStyle();
        this.getTaokes(this.page,this.public.getParam(),false);
      }
    },
    created(){
      (function(win,doc){
        var s = doc.createElement("script"), h = doc.getElementsByTagName("head")[0];
        if (!win.alimamatk_show) {
          s.charset = "gbk";
          s.async = true;
          s.src = "https://alimama.alicdn.com/tkapi.js";
          h.insertBefore(s, h.firstChild);
        };
        var o = {
          pid: "mm_121722189_26218996_368998773",/*推广单元ID，用于区分不同的推广渠道*/
          appkey: "23797077",/*通过TOP平台申请的appkey，设置后引导成交会关联appkey*/
          unid: "count",/*自定义统计字段*/
          type: "click" /* click 组件的入口标志 （使用click组件必设）*/
        };
        win.alimamatk_onload = win.alimamatk_onload || [];
        win.alimamatk_onload.push(o);
      })(window,document);
    },
    directives:{

    },
    components:{
      'v-double':Double,
      'v-tao':Tao
    },
    methods:{
      init(){
        this.isReload=false;
        this.isUpPage=false;
        this.isEnd=false;
        this.aliSearch = false;
        this.public.pageNumParam = '';
        this.page = 0;
        this.pageNum = 2;
        this.showToTop=false;
        this.top=window.screen.availHeight*2;
        this.noProduct=false;
        if(this.types==this.headType.h5Main){
          let t = document.getElementById("banner").offsetTop;
          let topH  = document.getElementById("contain-head").offsetTop;
          let height = topH-t;
          this.setScorllTop(height);
        }else if(this.types==this.headType.recommendMain){
          let t = document.getElementById("recommend").offsetTop;
          let topH  = document.getElementById("contain-head").offsetTop;
          let height = topH-t;
          this.setScorllTop(height);
        }
      },
      downToReload(){
        let self = this;
        if(self.getScrollHeight()-(self.getScrollTop()+self.getWindowHeight())>=-20 && self.getScrollHeight()-(self.getScrollTop()+self.getWindowHeight())<=20){
          if(self.scrollDirection=='down'){
            self.toLoadPage();
          }
        }
      },
      setStyle(){
        if(this.types==this.headType.h5Main || this.types==this.headType.recommendMain){
          this.bodyStyle = {height:'10000000px'};
        }else{
          this.bodyStyle = {};
        }
      },
      toShowToTop(){
        if(this.top>0 && this.scrollDirection=='down' && this.getScrollTop()>this.top){
          this.showToTop = true;
        }else if(this.top>0 && this.scrollDirection=='up' && this.getScrollTop()<=this.top){
          this.showToTop = false;
        }
      },
      floatBanner(){
        var self = this;
        let height = 370;
        let top='3rem';
        let h = self.headType;
        if(self.types== h.h5Main){
          try{
            let t = document.getElementById("banner").offsetTop;
            let topH  = document.getElementById("contain-head").offsetTop;
            height = topH-t;
            top="3rem";
          }catch(e){}
        }else if(self.types== h.cidHead){
          try{
            let t = document.getElementById("cid").offsetTop;
//          top="6.1rem";
            height = 0;
            top=t+"px";
          }catch(e){

          }
        }else if(self.types== h.searchResultHead){
          height = 0;
          top='3.2rem';
        }else if(self.types== h.recommend){
          height = 0;
          top='3rem';
        }else if(self.types== h.recommendMain){
          try{
            let t = document.getElementsByClassName("recommend-main")[0].offsetTop;
            let topH  = document.getElementById("contain-head").offsetTop;
            height = topH-t;
            top="3rem";
          }catch(e){}
        }else{
          height = 0;
          top="3.1rem";
        }
        if(self.type==this.showType.APP){
          height = 0;
          top = 0;
        }
        try{
          if(self.getScrollTop()>height){
            document.getElementById("top-contain").style.position='fixed';
            document.getElementById("top-contain").style.top=top;
            document.getElementById("top-contain").style.zIndex='100';
            document.getElementById("top-contain").style.width='100%';
            let element =document.getElementsByClassName("top-total")[0];
            let h =( element.currentStyle? element.currentStyle : window.getComputedStyle(element,null)).height;
            document.getElementById("contain-head").style.height = h;
          }else{
            document.getElementById("top-contain").style.position='';
            document.getElementById("top-contain").style.top='';
            document.getElementById("top-contain").style.zIndex='';
            document.getElementById("contain-head").style.height = 0;
            document.getElementById("top-contain").style.width = '';
          }
        }catch(e){

        }
      },
      getTaokes(page, param, upPage) {
        // 过滤解码url参数
        // t参数用于商品分类型页
        var goodsClassType = this.$route.query.t;
        if (goodsClassType) param += "&" + decodeURIComponent("t=" + goodsClassType);

        // q参数用于专题页
        var qParams = this.$route.query.q;
        if (qParams && param && param.indexOf('&t=') == -1) param += "&" + qParams;

        // 直接访问列表页面时，记录unionId和uid
        this.$route.query.unionId && this.setCookie("unionId", this.$route.query.unionId, 30);
        this.$route.query.uid && this.setCookie("unionId", this.$route.query.uid, 365);
        // console.log("unionId = " + this.$route.query.unionId + ", uid = " + this.$route.query.uid);

        var self = this;
        let url =this.https.getTaos+page+"?"+window.encodeURI(param);
        if((this.type==this.headType.share || this.type==this.headType.wxShare || this.type==this.headType.wxDetail) && typeof this.item!='undefined'){
          if(this.item.Cid){
            url = this.https.getTaos+this.item.Cid+"/"+page
          }else{
            url = this.https.getTaos+page+"?top=4&normal=1";
          }
        }
        if(this.isWeixin){
          url += "&disableRecommend=tr&disable_list_taobao=true&jd=1&pdd=1&appVersion=999&list_jd=1"
        }
        // taokeouts接口
        this.http.get(url).then(function(response){
          let data = response.data.d.map(function(item,index,array){
              item.page = self.page;
              return item;
          });

          //------------------------------------------------------
          //对分页数据 data 进行去重  得到结果 distinctArray
          var distinctArray = [];
          var tempIdArray1 = [];
          var tempIdArray2 = [];
          // 请求数据去重
          for(var d of data){
            tempIdArray1.indexOf(d.GoodsID) < 0 && tempIdArray1.push(d.GoodsID);
          }
          // 返回去重结果
          let tempArray2dist = function (tempArray) {
            for (var t of tempArray) {
              for (var d of data) {
                if (t == d.GoodsID) {
                  distinctArray.push(d);
                  break;
                }
              }
            }
          }
          if (upPage) { // 分页去重
            for (var t of tempIdArray1) {
              var add = 1;
              for (var st of self.taokes) {
                if (t == st.GoodsID) {
                  add = 0;
                  break;
                }
              }
              add && tempIdArray2.push(t);
            }
            tempArray2dist(tempIdArray2);
          } else {
            tempArray2dist(tempIdArray1);
          }

          //------------------------------------------------------
          if (upPage) { // 翻页
//            self.taokes = self.taokes.concat(data);
            self.taokes = self.taokes.concat(distinctArray);
          } else { // 刷新、筛选
//            self.taokes = data;
            self.taokes = distinctArray;
          }
          if(self.taokes.length<=0){
            self.isEnd = true;
            self.noProduct = true;
          }else{
            self.noProduct = false;
            self.isEnd = response.data.isOver;
          }
          self.aliSearch = response.data.aliSearch;
          self.isReload = true;
          self.isUpPage=false;
        }).catch(function(error){
          console.error(error)
        });
      },
      toLoadPage(){
        if(!this.isEnd){
          this.page++;
          if(this.aliSearch){
            this.public.pageNumParam = "pageNum="+this.pageNum;
            this.pageNum++;
          }
        }
      },
      count(){
        this.public.count(function(){},undefined,"l",this.types,this.page);
      },
      //滚动条在Y轴上的滚动距离
      getScrollTop(){
        var scrollTop = 0,bodyScorllTop= 0,documentScrollTop = 0;
        if(document.body){
          bodyScorllTop = document.body.scrollTop;
        }
        if(document.documentElement){
          documentScrollTop = document.documentElement.scrollTop;
        }
        scrollTop = (bodyScorllTop-documentScrollTop>0)?bodyScorllTop:documentScrollTop;
        return scrollTop;
      },
      setScorllTop(top){
        window.scrollTo(0,top);
      },
      //文档总高度
      getScrollHeight(){
        var scrollHeight = 0, bodyScrollHeight = 0, documentScrollHeight = 0;
        if(document.body){
          bodyScrollHeight = document.body.scrollHeight;
        }
        if(document.documentElement){
          documentScrollHeight = document.documentElement.scrollHeight;
        }
        scrollHeight = (bodyScrollHeight - documentScrollHeight > 0) ? bodyScrollHeight : documentScrollHeight;
        return scrollHeight;
      },
      gotoTop(){
        if(document.body.scrollTop){
          document.body.scrollTop=0;
        }else if(window.scrollTo){
          window.scrollTo(0,0)
        }
        this.showToTop = false;
      },
      //浏览器视口的高度
      getWindowHeight(){
        var windowHeight = 0;
        if(document.compatMode == "CSS1Compat"){
          windowHeight = document.documentElement.clientHeight;
        }else{
          windowHeight = document.body.clientHeight;
        }
        return windowHeight;
      },
      //判断浏览器滚动方向
      scrollFunc() {
        if (typeof this.scrollAction.x == 'undefined') {
          this.scrollAction.x = window.pageXOffset;
          this.scrollAction.y = window.pageYOffset;
        }
        var diffX = this.scrollAction.x - window.pageXOffset;
        var diffY = this.scrollAction.y - window.pageYOffset;
        if (diffX < 0) {
          // Scroll right
          this.scrollDirection = 'right';
        } else if (diffX > 0) {
          // Scroll left
          this.scrollDirection = 'left';
        } else if (diffY < 0) {
          // Scroll down
          this.scrollDirection = 'down';
        } else if (diffY > 0) {
          // Scroll up
          this.scrollDirection = 'up';
        } else {
          // First scroll event
        }
        this.scrollAction.x = window.pageXOffset;
        this.scrollAction.y = window.pageYOffset;
      },
      setCookie(key, value, day) {
        let date = new Date();
        date.setDate(date.getDate() + day);
        document.cookie = key + '=' + encodeURI(value) + ';expires=' + date;
      }
    }
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// Body.vue?54401fa4